function formatSealName(name, num) {
    const maxLength = num ?? 45
    const edgeLength = 22

    if (typeof name !== 'string') return '【暂无印章】'

    if (name.length <= maxLength) {
        return name
    }

    const prefix = name.slice(0, edgeLength)
    const suffix = name.slice(-edgeLength)
    return `${prefix}...${suffix}`
}

export default {
    mounted(el, binding) {
        const originalText = binding.value
        const formatted = formatSealName(originalText)
        el.style.wordBreak = 'break-all'
        el.textContent = formatted
    },
    updated(el, binding) {
        const originalText = binding.value
        const formatted = formatSealName(originalText)
        el.textContent = formatted
        el.style.wordBreak = 'break-all'
    }
}
